export enum RunSource {
    Cloud = 'Cloud',
    Local = 'Local',
    Freight = 'Freight',
    FreightBase = 'Freight Base',
    AllegroCase = 'Allegro Case',
    OppCost = 'Opp Cost'
}
